import React from "react";
import { Link } from "react-router-dom";
import { Image } from "primereact/image";
import { Avatar } from "primereact/avatar";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";

import { useBreakpoints } from "react-breakpoints-hook";

// logo
import logo from "../../assets/logo.svg";
import eca from "../../assets/eca.png";

//redux
import { useSelector, useDispatch } from "react-redux";
import { defaultImage } from "../../constants/IMAGES";
import LanguageSelect from "../customs/LanguageSelect";

export default function Navbar({ username, showMenu }) {
  const dispatch = useDispatch();
  const authenticateState = useSelector((state) => state.authenticate);
  const userState = useSelector((state) => state.user);

  let { lg } = useBreakpoints({
    lg: { min: 1101, max: null },
  });

  const navigate = useNavigate();

  return (
    <div
      className="bg-white py-1 lg:px-8 md:px-5 px-2 flex align-items-center justify-content-between shadow-md w-full fixed"
      style={{ zIndex: 1 }}
    >
      <div className="flex gap-2 align-items-center">
        <Button
          className={`b-button-sm p-button-text ${lg ? "hidden" : "flex"} `}
          icon="pi pi-bars text-xl"
          onClick={showMenu}
        />
        <div className="flex align-items-center justify-content-center gap-3">
          <Image
            imageClassName="cursor-pointer"
            imageStyle={{ objectFit: "cover" }}
            src={logo}
            height={30}
            onClick={() => {
              navigate(`/profile/${authenticateState.user_id}`);
              // navigate("/");
            }}
          />

          <LanguageSelect />
        </div>
      </div>

      <div className="flex gap-2 flex align-items-center mr-3">
        <Link to={`/profile/${authenticateState.user_id}`}>
          <Image
            src={authenticateState.user?.profileImage ?? defaultImage}
            imageClassName="border-circle h-3rem w-3rem"
            imageStyle={{ objectFit: "cover" }}
          />
        </Link>
        <span className="hidden md:flex">{authenticateState.user?.name}</span>
      </div>
    </div>
  );
}
